module.exports = __webpack_public_path__ + "static/26-b5551707c7e8d45455807e07e9c17651.png";